var React = require('react');

function IconMore (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","d":"M511.531 856.912c-41.295 0-74.771-33.476-74.771-74.771s33.476-74.771 74.771-74.771 74.771 33.476 74.771 74.771-33.476 74.771-74.771 74.771zm0-299.085c-41.295 0-74.771-33.476-74.771-74.771s33.476-74.771 74.771-74.771 74.771 33.476 74.771 74.771-33.476 74.771-74.771 74.771zm0-299.084c-41.295 0-74.771-33.476-74.771-74.771s33.476-74.771 74.771-74.771 74.771 33.476 74.771 74.771-33.476 74.771-74.771 74.771z","clipRule":"evenodd"}));
}

IconMore.displayName = "IconMore";

IconMore.defaultProps = {"viewBox":"15.167 -16.333 1000.636 1000.678"};

module.exports = IconMore;

IconMore.default = IconMore;
